if (typeof window.compareColor === 'undefined') {

    window.compareColor = function () {
        class CompareColor extends HTMLElement {
            constructor() {
                super();

                this.init();
            }

            init() {
                this.imageList = this.querySelector('.halo-compare-colors-image');
                this.textList = this.querySelector('[class*="compare-colors-text"]');
                this.debouncedOnChange = this.debounce((event) => {
                    this.onChangeHandler(event);
                    if (!this.classList.contains('node-loaded')) {
                        this.loadNode();
                    }
                }, 0);

                const list = this.querySelectorAll('ul li');

                list.forEach((item) => {
                    item.addEventListener('click', this.debouncedOnChange.bind(this));
                });
            }

            debounce(fn, delay) {
                let timer;
                return function (...args) {
                    clearTimeout(timer);
                    timer = setTimeout(() => fn.apply(this, args), delay);
                };
            }

            loadNode() {
                this.classList.add('node-loaded');
                this.onRemoveHandler();
            }

            onChangeHandler(event) {
                event.preventDefault();

                const label = event.target.closest('.swatch');
                if (!label || label.classList.contains('swatch--unavailable')) return;

                const itemSwatch = label;
                const id = label.getAttribute('data-value');

                if (!itemSwatch.classList.contains('active')) {
                    const title = label.getAttribute('data-title');
                    const image = label.getAttribute('data-variant-img');
                    if (!id || !title || !image || ['null', 'undefined'].includes(title.toLowerCase()) || ['null', 'undefined'].includes(image.toLowerCase())) return;

                    const item = document.createElement('div');
                    item.className = `item item-${id} item-compare-color`;
                    const imageWrapper = document.createElement('span');
                    const imageElement = document.createElement('img');
                    const titleElement = document.createElement('span');
                    imageWrapper.className = 'image';
                    imageElement.src = image;
                    imageElement.alt = title;
                    imageElement.width = 480;
                    imageElement.height = 480;
                    imageElement.decoding = 'async';
                    titleElement.className = 'title center';
                    titleElement.textContent = title;
                    imageWrapper.appendChild(imageElement);
                    item.append(imageWrapper, titleElement);
                    this.imageList.appendChild(item);
                    itemSwatch.classList.add('active');
                } else {
                    const item = this.imageList.querySelector(`.item-${id}`);
                    if (item) item.remove();
                    itemSwatch.classList.remove('active');
                }

                if (!this.textList) return;

                if (this.imageList.children.length > 0) {
                    this.textList.style.display = 'none';
                } else {
                    this.textList.style.display = 'block';
                }
            }

            onRemoveHandler() {
                this.imageList.addEventListener('click', (event) => {
                    const item = event.target.closest('.item');
                    if (item) {
                        event.preventDefault();
                        const classList = Array.from(item.classList);
                        const itemIdClass = classList.find(cls => cls.startsWith('item-') && !cls.includes('compare-color'));
                        const itemId = itemIdClass?.replace('item-', '');
                        const optionId = `swatch-compare-color-${itemId}`;
                        const input = document.getElementById(optionId);

                        if (input) {
                            input.click();
                        }
                    }
                });
            }

            onBodyClickEvent(event) {
                if (document.body.classList.contains('compare-color-show')) {
                    if (!this.contains(event.target) && !event.target.closest('[data-open-compare-color-popup], .halo-popup-content')) {
                        this.setClosePopup(event);
                    }
                }
            }
        }

        customElements.define('compare-color', CompareColor);
    };

    window.compareColor();
}
